import styled from 'styled-components';

export const GrayedOut = styled.div`
  opacity: 0.5;
  pointer-events: none;
`;
